import { LexicalEditor } from 'lexical'
import { convertLexicalToDBJson } from './JsonUtils'
import { ScreenplayPDFTemplate } from '../../pdf/ScreenplayPDFTemplate'
import { PdfService } from '@/shared/services/pdf.service'
import { KEYS } from '@/components/custom/editor/stringKeys/StringKeys'

export const handleDownload = async (
    fileName: string,
    editor: LexicalEditor,
    authorName?: string
) => {
    if (typeof window !== 'undefined') {
        try {
            console.log('Generating Screenplay PDF from AST...')
            const editorState = editor.getEditorState()

            let blocks: any[] = []
            editorState.read(() => {
                blocks = convertLexicalToDBJson(editorState.toJSON())
            })

            console.log('Extracted Lexical Blocks:', blocks.length)

            const brandLogoBase64 = await PdfService.fetchBrandLogoBase64()

            const pdfDoc = (
                <ScreenplayPDFTemplate
                    blocks={blocks}
                    brandLogoBase64={brandLogoBase64}
                    projectTitle={fileName}
                    authorName={authorName}
                />
            )
            const documentTitle = `${fileName}-screenplay.pdf`

            await PdfService.downloadReactPdfDocument(pdfDoc, documentTitle)

            console.log('PDF downloaded successfully via React-PDF')
        } catch (error) {
            console.error('Error downloading PDF:', error)
            alert('Failed to download Screenplay PDF.')
        }
    }
}

export const handleDownloadHtml2PDF = async (fileName: string) => {
    if (typeof window !== 'undefined') {
        try {
            // const html2pdf = (await import('html2pdf.js')).default
            // const options = {
            //     margin: 10,
            //     filename: `${fileName}-screenplay.pdf`,
            //     image: { type: 'jpeg', quality: 0.98 },
            //     html2canvas: { scale: 2 },
            //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            // }
            // const element = document.getElementById(KEYS.SP_PDF_CONTENT)?.innerHTML
            // html2pdf()
            //     .from(element)
            //     .set(options)
            //     .save()
            //     .then(() => {
            //         console.log('PDF downloaded successfully')
            //     })
            //     .catch((error: any) => {
            //         console.error('Error downloading PDF:', error)
            //     })
        } catch (error) {
            console.error('Error loading html2pdf.js:', error)
        }
    }
}
